export class DebuggerWatchEntry {
    constructor(public term: string){

    }
}